import React from "react";
import { Building, Users } from "lucide-react";
import type { Site } from "../types/dashboard.js";
import { HealthBadge } from "./SeverityBadge.js";

export default function SiteHealthCard({ site }: { site: Site }): React.ReactElement {
  const barColor =
    site.health === "critical"
      ? "bg-danger"
      : site.health === "warning"
        ? "bg-warning"
        : "bg-success";
  return (
    <div className="card p-4 transition-colors hover:border-border-strong">
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 text-text-primary">
            <Building className="h-4 w-4 text-text-secondary flex-shrink-0" />
            <span className="font-medium truncate">{site.name}</span>
          </div>
          <p className="mt-0.5 text-xs text-text-secondary truncate">{site.client}</p>
        </div>
        <HealthBadge health={site.health} />
      </div>
      <div className="mt-3 flex items-center gap-3 text-xs text-text-secondary">
        <span className="flex items-center gap-1">
          <Users className="h-3 w-3" />
          <span>{site.activeOfficers} 在勤</span>
        </span>
        <span className="font-mono">最後感應 · {site.lastTap}</span>
      </div>
      <div className="mt-3">
        <div className="flex items-center justify-between text-xs">
          <span className="text-text-secondary">完成率</span>
          <span className="text-text-primary font-mono tabular-nums">{site.completion}%</span>
        </div>
        <div className="mt-1.5 h-1.5 w-full overflow-hidden rounded-full bg-bg-raised">
          <div
            className={`h-full ${barColor} transition-all`}
            style={{ width: `${site.completion}%` }}
          />
        </div>
      </div>
    </div>
  );
}
